// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var ViewStack = require("../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../reason/common/Theme/Theme__Color__Vars.bs.js");
var Colors = require("uikit/styles/colors");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RentalNeedLeaseAttributes_rentalNeedV5_graphql = require("../../__generated__/RentalNeedLeaseAttributes_rentalNeedV5_graphql.bs.js");

var convertFragment = RentalNeedLeaseAttributes_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalNeedLeaseAttributes(props) {
  var match = use(props.rentalNeed);
  var availableFrom = match.availableFrom;
  var tmp;
  if (availableFrom !== undefined) {
    var from = DateFns.format(CalendarDate.toLocalDate(Caml_option.valFromOption(availableFrom)), "M/d");
    tmp = " available on or before " + from;
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "lease requirements",
              children: JsxRuntime.jsxs(ViewStack.make, {
                    space: "sm",
                    flexDirection: "row",
                    children: [
                      JsxRuntime.jsx(Icon__Jsx3.make, {
                            icon: "Calendar",
                            color: Theme__Color__Vars.chicago
                          }),
                      JsxRuntime.jsxs(Text__Jsx3.make, {
                            color: Colors.mineShaft,
                            children: [
                              match.leaseLength.displayName + " term",
                              tmp
                            ]
                          })
                    ]
                  })
            });
}

var make = RentalNeedLeaseAttributes;

exports.Fragment = Fragment;
exports.make = make;
/* date-fns Not a pure module */
